import { Loading, SplitPanel } from '@components/atomic/atoms';
import CheckList from '@components/checklist/checkList';
import { UserContext } from '@components/contexts/UserProvider';
import UploadDocument from '@components/form/upload/uploadDocuments';
import { IcoClose } from '@icons';
import { getModalData } from '@lib/api';
// import { dateFormatter, formatToDecimals } from '@lib/helpers/formatting';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import React, { /*Fragment,*/ useContext, useState } from 'react';
import { Button, /*Col, Form,*/ Modal /*, Row*/ } from 'react-bootstrap';
import { ResumeChecklistProjectType } from './ResumeChecklistCellRenderer';
// import StopLightWithMessage from './StopLightWithMessage';
import SummaryContractModalInfo from './SummaryContractModalInfo';
import SummaryDownloadList from './SummaryDownloadList';
import { useHasPermission } from '@lib/hooks/useHasPermission';
// import SummaryContractModalInfo from './SummaryContractModalInfo';

interface SummaryContractModalProps {
	show: boolean;
	onHide: () => void;
	apiUrl: string;
	project: ResumeChecklistProjectType;
}

export type ContractDataType = {
	id: number;
	supplierName?: string;
	supplierCode?: string;
	vatNumber?: string;
	number: string;
	date?: string;
	po: boolean;
	project?: {
		cupType: string;
		cup?: string;
		startDate?: string;
	};
	frameworkContract?: {
		number: string;
		tender?: {
			tenderNumber: string;
		};
	};
	cigs?: {
		id: number;
		cig: string;
	}[];
	baseAmount?: number;
	paymentId?: number;
	contractId?: number;
	reported: boolean;
	reporting: boolean;
	payments?: {
		pivot: {
			id: number;
		};
	}[];
	checkliststatus?: {
		color: string;
	};
};

const SummaryContractModal: React.FC<SummaryContractModalProps> = ({ show, onHide: onHideFromParent, apiUrl, project }) => {
	const { userAccess } = useContext(UserContext);

	const { data: modalData, isPending: isPendingModalData } = useQuery<{
		data: ContractDataType;
	}>({
		queryKey: ['modalData', apiUrl],
		queryFn: () => getModalData(apiUrl),
		enabled: show,
	});
	const contractData = modalData?.data;

	const queryClient = useQueryClient();
	const invalidateInvoicesQuery = () => {
		queryClient.invalidateQueries({ queryKey: ['resumeInvoices'] });
	};

	const [isEdited, setIsEdited] = useState(false);
	const onHide = () => {
		if (isEdited) {
			invalidateInvoicesQuery();
		}
		setIsEdited(false);
		onHideFromParent();
	};

	const isDisabled = contractData?.reported || contractData?.reporting || (!userAccess.isPartner && !userAccess.isGuestEnteErogante);

	const shouldShowChecklist = useHasPermission('view-checklists');

	return (
		<Modal fullscreen show={show} onHide={onHide}>
			<Modal.Header
				style={{
					padding: '2rem',
					justifyContent: 'space-between',
				}}
			>
				<Modal.Title>
					<h2 style={{ fontSize: '28px', marginBottom: '0.5rem' }}>Controllo del contratto/attingimento {contractData?.id}</h2>
					<h3
						style={{
							fontSize: '18px',
							fontWeight: 700,
						}}
					>
						PROGETTO: {project.name}
					</h3>
				</Modal.Title>
				<Button
					className="btn custom-ghost-button"
					onClick={onHide}
					style={{
						color: 'var(--np-primary-color)',
						display: 'flex',
						alignItems: 'center',
						gap: '0.75rem',
					}}
				>
					Chiudi
					<IcoClose
						style={{
							fill: 'var(--np-primary-color)',
						}}
					/>
				</Button>
			</Modal.Header>
			<Modal.Body
				style={{
					padding: '2rem',
					overflow: 'hidden',
				}}
			>
				{isPendingModalData ? (
					<Loading />
				) : show ? (
					<SplitPanel
						panels={[
							{
								key: 'info',
								title: 'Informazioni',
								content: <SummaryContractModalInfo contractData={contractData!} project={project} />,
								...(shouldShowChecklist ? { defaultIsVisible: false } : {}),
							},
							{
								key: 'documents',
								title: 'Documenti',
								content: (
									<div>
										<UploadDocument entity="contracts" entityId={contractData.id} title="Documenti correlati" />
									</div>
								),
							},
							...(shouldShowChecklist
								? [
										{
											key: 'checklist',
											title: 'Checklist',
											content: (
												<div className="custom-checklist-container">
													<div>
														<h4>Checklist per il controllo</h4>
														<SummaryDownloadList
															entity={{
																entityType: 'contracts',
																entityId: contractData.id,
																label: 'contratti/attingimenti',
															}}
														/>
													</div>
													{/* <h4>Checklist per il controllo</h4> */}
													{contractData.id && (
														<CheckList
															hasStandardChecklist={false}
															entityType="contracts"
															entityId={contractData.id}
															disabled={isDisabled}
															hasInternalDownload={false}
															hasEnabledAi={project.aiEnabled}
														/>
													)}
												</div>
											),
										},
									]
								: []),
						]}
					/>
				) : null}
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={onHide} className="btn custom-outline-button custom-medium-button">
					Annulla
				</Button>
				{shouldShowChecklist ? (
					<Button
						onClick={() => {
							setIsEdited(true);
						}}
						disabled={isDisabled}
						type="submit"
						form="checklist-contracts"
						className="btn custom-primary-button custom-medium-button"
					>
						Salva risposte
					</Button>
				) : null}
			</Modal.Footer>
		</Modal>
	);
};

export default SummaryContractModal;
